export const CONTACT_INFO = {
  name: "Haveglæde v/Michael Poul Ewers Petersen",
  address: "Vestervænget 10, 6710 Esbjerg V",
  phone: "29 90 77 31",
  phoneRaw: "+4529907731",
  email: "michael@haveglaede.dk",
  cvr: "33618697",
  hours: "Mandag - fredag: 08.00 - 16.00",
  hoursWeekend: "Lørdag og søndag: lukket",
  hoursMails: "Mails besvares alle dage."
};

export const SERVICES = [
  {
    title: "Haveservice",
    slug: "haveservice",
    icon: "fa-regular fa-seedling",
    shortDesc: "Professionel haveservice og grøn pleje året rundt for private og erhverv.",
    benefits: [
      "Vinterklar have og frostsikring",
      "Professionel græsslåning og pleje",
      "Effektiv lugning og ukrudtsbekæmpelse",
      "Feriepasning af haven mens du er væk"
    ]
  },
  {
    title: "Anlæg af have",
    slug: "anlaeg-af-have",
    icon: "fa-regular fa-shovel",
    shortDesc: "Nyanlæg, omlægning af bede og grønne uderum tilpasset dine drømme.",
    benefits: [
      "Etablering af nye bede og græsplæner",
      "Omlægning af eksisterende havearealer",
      "Professionel rådgivning og planlægning",
      "Bortskaffelse af alt haveaffald"
    ]
  },
  {
    title: "Belægning",
    slug: "belaegning",
    icon: "fa-regular fa-road",
    shortDesc: "Smukke og holdbare belægninger til indkørsler, stier og terrasser.",
    benefits: [
      "Præcis lægning af fliser og sten",
      "Solidt underlag der sikrer lang holdbarhed",
      "Flotte terrasser, stier og indkørsler",
      "Kvalitetsmaterialer tilpasset dansk vejr"
    ]
  },
  {
    title: "Beskæring",
    slug: "beskaering",
    icon: "fa-regular fa-scissors",
    shortDesc: "Professionel beskæring af træer, buske og frugttræer for sund vækst.",
    benefits: [
      "Korrekt og skånsom beskæring",
      "Bedre lysindfald og sundere planter",
      "Beskæring af frugttræer for optimal høst",
      "Sikker nedskæring af store buske"
    ]
  },
  {
    title: "Hækklipning",
    slug: "haekklipning",
    icon: "fa-regular fa-trees",
    shortDesc: "Knivskarp hækklipning af alle typer hække med professionelt udstyr.",
    benefits: [
      "Snorlige og tætte hække",
      "Klipning af alle hæktyper (bøg, liguster, gran m.m.)",
      "Hurtig og effektiv udførelse",
      "Altid pæn oprydning efter arbejdet"
    ]
  },
  {
    title: "Vedligeholdelse",
    slug: "vedligeholdelse",
    icon: "fa-regular fa-sparkles",
    shortDesc: "Løbende vedligeholdelse af haver og grønne arealer efter fast aftale.",
    benefits: [
      "Skræddersyede serviceaftaler",
      "Fast timepris uden grimme overraskelser",
      "Ukrudtsbekæmpelse og fejning",
      "Pleje af græsarealer og fællesområder"
    ]
  }
];

export const REVIEWS = [
  {
    text: "Michael leverede et fantastisk stykke arbejde med vores hæk. Den står snorlige, og alt haveaffald blev fjernet med det samme. Kan varmt anbefales!",
    author: "Hanne S.",
    location: "Esbjerg"
  },
  {
    text: "Professionel og pålidelig gartner. Vores nye belægning på terrassen er blevet præcis som vi ønskede os. Flot håndværk!",
    author: "Jens P.",
    location: "Esbjerg V"
  },
  {
    text: "Haveglæde har passet vores have i hele sommerferien. Det har været en sand fornøjelse at komme hjem til en velplejet have. Super service!",
    author: "Birgitte M.",
    location: "Hjerting"
  },
  {
    text: "Hurtig og effektiv beskæring af vores gamle æbletræer. Michael ved virkelig, hvad han laver, og prisen var yderst rimelig.",
    author: "Morten K.",
    location: "Esbjerg"
  },
  {
    text: "Vi har en fast aftale om havevedligeholdelse med Haveglæde, og det fungerer bare upåklageligt. Altid venlig og professionel service.",
    author: "Esbjerg Erhverv",
    location: "Esbjerg"
  },
  {
    text: "Fantastisk rådgivning omkring omlægning af vores baghave. Michael kom med gode idéer, som vi aldrig selv havde tænkt på.",
    author: "Kirsten & Poul",
    location: "Sædding"
  }
];
